let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aoPK2")).then(() => parcelRequire('5ACVQ'));